import { useState } from 'react'
import Textarea from 'components/textarea/textarea.component'
import { IHelpCenter } from 'interfaces/BaseInterface'
import { sendHelpCenterMessage } from 'services/setting.service'
import { displayError, displaySuccess } from 'components/Toast/toast.component'
import { useMutation } from '@tanstack/react-query'
import Button from 'components/button/button'

const HelpCenterScreen: React.FC = () => {
  const [message, setMessage] = useState<IHelpCenter>({
    message: '',
  })
  const {
    data: helpMessage,
    isPending,
    mutateAsync: sendHelpAsync,
  } = useMutation({
    mutationFn: () => sendHelpCenterMessage(message),
    retry: 0,
    onSuccess: () => {
      displaySuccess('Your message has been sent to glimpse team.')
      setMessage({ message: '' })
    },
  })
  // const newValue = message.message.replace(/\s/, "");

  return (
    <div>
      <div className="flex flex-col">
        <p className="text-xl font-normal leading-6 text-black">
          How can we help?
        </p>
        <p className="text-sm font-normal leading-5 text-gray">
          To contact someone on the CareerSight team, please fill out this form. We
          will respond within 1-2 business days.
        </p>
      </div>
      <div className="flex flex-col mt-[19px] max-w-[553px]">
        <Textarea
          rows={6}
          name="help_content"
          id="help_content"
          showLabel={true}
          label="Message"
          value={message.message}
          onChange={ev => {
            setMessage({ message: ev.target.value })
          }}
          placeholder="Message here..."
        />
      </div>
      <Button
        variant="primary"
        type="button"
        disabled={isPending || message.message.length === 0}
        onClick={e => {
          if (message.message.trim()) {
            sendHelpAsync()
          } else {
            displayError('Please input your message')
          }
        }}
        className="min-w-[120px] mt-[17px]"
      >
        {isPending ? 'Sending...' : 'Send'}
      </Button>
    </div>
  )
}

export default HelpCenterScreen
